'use client'

import { Button, Navigation } from '@vinted/web-ui'
import { X24 } from '@vinted/monochrome-icons'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/bundles/items-bundle-data'

import BundleHeaderSubtitle from '../BundleHeaderSubtitle'

export type Props = {
  discountHint?: string
  pathBack: string
}

const BundleHeaderWithNavigation = ({ discountHint, pathBack }: Props) => {
  const { track } = useTracking()
  const { safeBack } = useBrowserNavigation()

  const trackCloseAction = () => {
    track(
      clickEvent({
        target: 'cancel_bundle',
      }),
    )
    safeBack(pathBack)
  }

  const renderCloseButton = () => (
    <Button
      iconName={X24}
      styling="flat"
      inline
      onClick={trackCloseAction}
      testId="bundle-header-close-button"
    />
  )

  const renderSubtitle = () => <BundleHeaderSubtitle discountHint={discountHint} />

  return <Navigation left={renderCloseButton()} body={renderSubtitle()} />
}

export default BundleHeaderWithNavigation
